export default "__VITE_ASSET__CPuYzZ4g__"